// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ycQA","tabsBox":"styles_tabsBox__2MSoX","createButton":"styles_createButton__-kOTg"};